import React from 'react';
import { Row, Button, Modal, ModalHeader, ModalBody } from "reactstrap";
import '../../i18/config';
import { useTranslation } from "react-i18next";
import LeftbarTitle from "../LeftbarTitle";
import { LordIcon } from "../LordIcon";
import ButtonSpinner from "../ButtonSpinner";

interface AddPasskeyFormProps {
    isOpen: boolean;
    onSkip: () => void;
    onCreate: () => void;
    isLoading: boolean;
}

const AddPasskeyForm = ({ isOpen, onSkip, onCreate, isLoading }: AddPasskeyFormProps) => {
    const { t } = useTranslation(['auth', 'common']);

    return (
        <Modal isOpen={isOpen} centered backdrop="static" toggle={onSkip}>
            <ModalHeader toggle={onSkip}>
                <LeftbarTitle title={t('auth:registerWithPasskey')}/>
            </ModalHeader>
            <ModalBody>
                <Row>
                    <div className="mt-2 text-center">
                        <LordIcon
                            src="https://cdn.lordicon.com/urswgamh.json"
                            trigger="loop"
                            colors={{primary: '#0ab39c',secondary:'#32b67d'}}
                            size={120}
                        />
                    </div>
                </Row>
                <Row>
                    <div className="mt-4 text-center">
                        <p className="text-muted mb-4">{t('auth:passkeySuggestionBody')}</p>

                        <div className="hstack gap-2 justify-content-center">

                            <Button color="light"
                                    type="button"
                                    onClick={onSkip}
                                    className="btn btn-label waves-effect waves-light"
                            ><i className="ri-close-line align-bottom label-icon"/>
                                {t('common:later')}
                            </Button>

                            <Button color="success"
                                    type="button"
                                    onClick={onCreate}
                                    disabled={isLoading}
                                    className="btn btn-label waves-effect waves-light"
                            ><i className="ri-check-double-line align-bottom label-icon"/>
                                {t('common:addNew')}
                                {isLoading &&
                                    <ButtonSpinner/>
                                }
                            </Button>

                        </div>
                    </div>
                </Row>
            </ModalBody>
        </Modal>
    );
};

export default AddPasskeyForm;
